import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { Cases } from "~/components/Cases/Cases"
import { ContactForm } from "~/components/ContactForm/ContactForm"
import { Layout } from "~/components/Layout/Layout"
import { Programs } from "~/components/Programs/Programs"

import { Hero } from "./components/Hero/Hero"
import { IndexesAndRaitings } from "./components/IndexesAndRaitings/IndexesAndRaitings"
import { News } from "./components/News/News"
import { Principles } from "./components/Principles/Principles"
import { SocialInvestment } from "./components/SocialInvestment/SocialInvestment"
import styles from "./index.module.css"

const SustainableDevelopment: React.FC = () => {
  const { t } = useTranslation()

  const { items: caseItems } = useApiContext("/sustainablecases/list")

  return (
    <Layout
      description={t("sustainable-development.Hero.Description")}
      headerTheme="onDark"
      title={t("page.sustainable-development")}
    >
      <Hero />
      <Principles />
      <IndexesAndRaitings />
      <SocialInvestment />
      {/*<Charity />*/}
      <Programs />
      <Cases
        items={caseItems}
        linkName={t("sustainable-development.Cases.Link")}
        title={t("sustainable-development.Cases.Title")}
      />
      <News />
      <ContactForm
        content={() => (
          <>
            {/* hidden by task #5 */}
            {/*<div*/}
            {/*  dangerouslySetInnerHTML={{ __html: t("sustainable-development.BlueForm.Content") }}*/}
            {/*/>*/}
            <div className={styles.Item}>
              <a href="mailto:esg@sistema.ru">esg@sistema.ru</a>
            </div>
            <div className="d-none d-sm-block" />
          </>
        )}
        title={t("sustainable-development.BlueForm.Title")}
        showMobileText
      />
    </Layout>
  )
}

export default SustainableDevelopment
